// extracted by mini-css-extract-plugin
export default {"PhotoCropInput":"bfm_a"};